const moeda = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
export const formatarMoeda = (v: number) => moeda.format(v);

const hora = new Intl.DateTimeFormat("pt-BR", { hour: "2-digit", minute: "2-digit" });
const diaMes = new Intl.DateTimeFormat("pt-BR", { day: "2-digit", month: "2-digit" });
const dataCompleta = new Intl.DateTimeFormat("pt-BR", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
});

export function horaOuData(iso: string, agora = new Date()): string {
  const d = new Date(iso);
  if (d.toDateString() === agora.toDateString()) return hora.format(d);
  const ontem = new Date(agora);
  ontem.setDate(agora.getDate() - 1);
  if (d.toDateString() === ontem.toDateString()) return "Ontem";
  return diaMes.format(d);
}

export const formatarHora = (iso: string) => hora.format(new Date(iso));
export const formatarData = (iso: string) => dataCompleta.format(new Date(iso));

/** "agora", "4 min", "1 h 12 min", "2 d". */
export function duracaoCurta(desdeIso: string, agora = Date.now()): string {
  const min = Math.max(0, Math.floor((agora - new Date(desdeIso).getTime()) / 60_000));
  if (min < 1) return "agora";
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return min % 60 ? `${h} h ${min % 60} min` : `${h} h`;
  return `${Math.floor(h / 24)} d`;
}

/** Níveis de espera: limites configurados pela gerência (ver useLimitesEspera). */
export type { NivelEspera } from "@ydchat/shared";
export { nivelEspera } from "@ydchat/shared";

export function iniciais(nome: string): string {
  const partes = nome
    .replace(/[^\p{L}\s]/gu, "")
    .trim()
    .split(/\s+/);
  return (
    (
      (partes[0]?.[0] ?? "") + (partes.length > 1 ? (partes[partes.length - 1]?.[0] ?? "") : "")
    ).toUpperCase() || "?"
  );
}
